import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import ordersReducer from "./slices/ordersSlice";
import customersReducer from "./slices/customersSlice";
import warehousesReducer from "./slices/warehousesSlice";
import tripsReducer from "./slices/tripsSlice";
import vehiclesReducer from "./slices/vehiclesSlice";
import couriersReducer from "./slices/couriersSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    orders: ordersReducer,
    customers: customersReducer,
    warehouses: warehousesReducer,
    trips: tripsReducer,
    vehicles: vehiclesReducer,
    couriers: couriersReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
